/** Mirror backend/src/utils/whatsapp-utm.util.ts for template builder UI. */
export const WHATSAPP_CAMPAIGN_WELCOME_UTM = {
  utm_source: 'whatsapp',
  utm_medium: 'campaign_welcome',
  utm_campaign: 'true_artis_campaign_welcome',
} as const;

function utmContentForMarketingUrl(url: string): string {
  try {
    const normalized = url.trim().startsWith('http') ? url.trim() : `https://${url.trim()}`;
    const u = new URL(normalized);
    if (u.hostname.toLowerCase().includes('instagram.com')) return 'instagram';
    const path = u.pathname.toLowerCase();
    if (path.includes('bookappointment')) return 'book_appointment';
    if (path.includes('press-release')) return 'press_releases';
    if (path === '/' || path === '') return 'home';
    return path.replace(/^\//, '').replace(/\//g, '_').slice(0, 80) || 'link';
  } catch {
    return 'link';
  }
}

function appendUtmToUrl(
  url: string,
  utm: typeof WHATSAPP_CAMPAIGN_WELCOME_UTM & { utm_content?: string }
): string {
  try {
    const u = new URL(url.trim());
    if (!u.searchParams.has('utm_source')) u.searchParams.set('utm_source', utm.utm_source);
    if (!u.searchParams.has('utm_medium')) u.searchParams.set('utm_medium', utm.utm_medium);
    if (!u.searchParams.has('utm_campaign')) u.searchParams.set('utm_campaign', utm.utm_campaign);
    if (utm.utm_content && !u.searchParams.has('utm_content')) {
      u.searchParams.set('utm_content', utm.utm_content);
    }
    return u.toString();
  } catch {
    return url;
  }
}

const URL_IN_TEXT = /\bhttps?:\/\/[^\s<>"']+/gi;

/** Append standard welcome UTMs to each trueartis.com link in template body (for Meta approval). */
export function appendWelcomeUtmToTemplateBody(bodyText: string): string {
  return bodyText.replace(URL_IN_TEXT, (match) => {
    if (utmContentForMarketingUrl(match) === 'instagram') return match;
    return appendUtmToUrl(match, {
      ...WHATSAPP_CAMPAIGN_WELCOME_UTM,
      utm_content: utmContentForMarketingUrl(match),
    });
  });
}
